import React from 'react';
import { FlameIcon } from 'lucide-react';
export function ScarcityBar() {
  const spotsLeft = 9;
  const percentFilled = 91;
  return <div className="mx-auto w-full max-w-md rounded-2xl border border-magenta/20 bg-white/80 p-4 shadow-sm backdrop-blur" data-id="element-216" data-mp="2yvt76lzgnhwq">
      <div className="mb-2 flex items-center justify-between" data-id="element-217" data-mp="2l33ho7kq3uuv">
        <span className="flex items-center gap-1.5 text-sm font-bold text-magenta" data-id="element-218" data-mp="2q2ptqdotf523">
          <FlameIcon className="h-4 w-4 animate-pulse" data-id="element-219" data-mp="2b5p1m92pp833" />
          ¡Cupos casi agotados!
        </span>
        <span className="text-xs font-semibold text-plum/70" data-id="element-220" data-mp="2g6w7g2lanx74">
          Quedan {spotsLeft} cupos
        </span>
      </div>
      <div className="relative h-3 w-full overflow-hidden rounded-full bg-plum/10" data-id="element-221" data-mp="227wl51l97ue4">
        <div className="h-full rounded-full bg-gradient-to-r from-magenta to-pink transition-all duration-700" style={{
        width: `${percentFilled}%`
      }} data-id="element-222" data-mp="275y4zoqi7xqn">
          <div className="h-full w-full animate-pulse bg-white/20" data-id="element-223" data-mp="5e1r48gv6bsp" />
        </div>
      </div>
      <p className="mt-2 text-center text-xs text-plum/60" data-id="element-224" data-mp="33m3cjccthjh1">
        {percentFilled}% de los cupos con precio promocional ya reservados
      </p>
    </div>;
}